/* eslint-disable react-hooks/exhaustive-deps */

import { createRef, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Box, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { QuickLinksComponent, QuickSearchComponent, StartQuoteComponent, UserSelectComponent, LoadingComponent } from '../../components';
import '../../common/theme/CommonStyles.scss';
import './AgentShopfloorHome.scss';
import appSettings from '../../appSettings';
import parse from 'html-react-parser';
import { useFormSubmit } from '../../utils/useFormSubmit';
import constants from '../../constants';

const AgentShopfloorHome = ({ refreshToken, hasMultipleUsernames, selectedUser, handleChange, boxLinkData, quickLinkData, accounts, currentUser, agencyName, isAgentDropdownOpen, setAgentDropdownOpen, setShowGlobalBanner, scrollToTop, navAgencyManagement, showReportingCommonModal, openGlobalBanner, handleNavigate }) => {
  const history = useHistory();
  const location = useLocation();
  const loading = useSelector(state => state.loading);
  const contact = useSelector(state => state.contact);
  const agentProfile = useSelector(state => state.selectedProfile);
  const legacyProfileId = agentProfile.lpId;
  const [activeBoxIndex, setActiveBoxIndex] = useState(0);
  const [scrolling, setScrolling] = useState(true);
  const [isSubAgentDropdownOpen, setSubAgentDropdownOpen] = useState(false);
  const scrollRefs = useRef([]);
  const navRefs = useRef([]);
  const forwardArrow = require('../../img/forward-arrow-white.png');
  const boxWidth = 210;
  const numberOfBoxes = 4;
  const message = contact.firstName + " " + contact.lastName + "\t" + legacyProfileId;
  const encodedMessage = encodeURIComponent(message);
  const { formRef, inputRef, handleSubmit } = useFormSubmit(encodedMessage);

  scrollRefs.current = [...Array(boxLinkData.length).keys()].map(
    (_, i) => scrollRefs.current[i] ?? createRef()
  );

  navRefs.current = [...Array(boxLinkData.length).keys()].map(
    (_, i) => navRefs.current[i] ?? createRef()
  );

  const handleBoxDotClick = (index) => {
    setScrolling(true);
    scrollRefs.current[index].current.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start',
    });
    setActiveBoxIndex(index);
  };
  
  const handleScroll = (e) => {
    const container = e.target;
    const scrollLeft = container.scrollLeft;
    const newIndex = Math.floor(scrollLeft / boxWidth);
    setActiveBoxIndex(newIndex);
  };

  useEffect(() => {
    if(isAgentDropdownOpen === true) {
      const updatedSearchParams = new URLSearchParams(location.search);
      updatedSearchParams.delete('dropdown');
      history.replace({
        pathname: location.pathname,
        search: updatedSearchParams.toString(),
      });    
    }
  }, [isAgentDropdownOpen]);

  useEffect(() => {
    if(!loading && accounts.length > 0) {
      const container = hasMultipleUsernames ? document.querySelector('.boxLink-container') : document.querySelector('.quick-boxLink-container');
      const handleScrollEvent = (e) => {
        if (!scrolling) {
          handleScroll(e);
        }
      };
      container.addEventListener('scroll', handleScrollEvent);
      return () => {
        container.removeEventListener('scroll', handleScrollEvent);
      };
    }
  }, [scrolling, loading]);
  
  useEffect(() => {
    if (scrolling) {
      const timeoutId = setTimeout(() => {
        setScrolling(false);
      }, 1000);
  
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [scrolling]);

  useEffect(() => {
    scrollToTop();
  }, []);
  
  
  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <>
      <Box className='shopfloor-banner-with-text-container'>
        <picture>
          <img className='hero-image' src={require('../../common/assets/img/hero-image-desktop.png')} alt='shopfloor-banner' />
        </picture>
        <Box className='shopfloor-greeting-container'>
          <Box className='amsuiteplus-logo'><img src={require('../../common/assets/img/amsuiteplus-logo.png')} alt='amsuiteplus-logo' /></Box>
          <Box className='shopfloor-banner-text-outer'>
          {agencyName && (
            <>
            <Box className='greeting-username'>
                <span>
                  {typeof agencyName === 'string' && agencyName.trim() !== '' ? agencyName + ' ' : ' '}
                </span>              
                Username: {currentUser.prismId}
              </Box>
              <Box className='greeting-profile' fontWeight='bold'>
                Welcome, {contact.firstName}!
              </Box>
            </>
            )}
          </Box>
        </Box>
      </Box>
      <Box className='shopfloor agent-ciam-container'>
        <Box className='shopfloor-content'>
          <Box className='shopfloor-container'>
            <Box className='shopfloor-styling'>
              <Grid>
                {hasMultipleUsernames && (
                  <Box className='user-select-container'>
                    <UserSelectComponent handleChange={handleChange} selectedUser={selectedUser} ></UserSelectComponent>
                  </Box>
                )}
                <StartQuoteComponent refreshToken={refreshToken} isAgentDropdownOpen={isAgentDropdownOpen} isSubAgentDropdownOpen={isSubAgentDropdownOpen} setAgentDropdownOpen={setAgentDropdownOpen} setSubAgentDropdownOpen={setSubAgentDropdownOpen} openGlobalBanner={openGlobalBanner} hideErrorBanner={() => { setShowGlobalBanner(false) }}></StartQuoteComponent>
              </Grid>
              <Grid className='right-section'>
                <Box className='right-section-box'>
                  {hasMultipleUsernames && (
                    <Box className='user-select-right-container'>
                      <UserSelectComponent handleChange={handleChange} selectedUser={selectedUser}></UserSelectComponent>
                    </Box>
                  )}
                  <Box className='quick-box'>
                    <QuickLinksComponent quickLinkData={quickLinkData} currentUser={currentUser.prismId} showReportingCommonModal={showReportingCommonModal} natPayEncodedMessage={encodedMessage}></QuickLinksComponent>
                    <QuickSearchComponent user={selectedUser.new}></QuickSearchComponent>
                  </Box>
                  {!hasMultipleUsernames && renderQuickActions()}
                </Box>
              </Grid>
            </Box>
            {hasMultipleUsernames && renderQuickActions(true)}
            <Box className='boxNavigation'>
              {Array.from({ length: numberOfBoxes }).map((_, index) => (
                <div
                  key={index}
                  ref={navRefs.current[index]}
                  className={`boxDot ${index === activeBoxIndex ? 'active' : ''}`}
                  onClick={() => handleBoxDotClick(index)}
                ></div>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
  
  // Helper function to render quick actions
  function renderQuickActions(isMultipleUsers = false) {
    return (
      <>
        <Box className='boxLink-title'>Quick Actions</Box>
        <Box className={isMultipleUsers ? 'boxLink-container' : 'quick-boxLink-container'}>
          <Box className={isMultipleUsers ? 'boxLink-inner-container-short' : 'quick-boxLink-inner-container'}>
            {Array.from({ length: numberOfBoxes }).map((_, index) => renderQuickActionBox(index))}
          </Box>
        </Box>
      </>
    );
  }
  
  function renderQuickActionBox(index) {
    const box = boxLinkData[index];
    if (!box) {
      return null;
    };
  
    const text = box.text.toLowerCase();
    const actionTypes = {
      policyManagement: text.includes(constants.amsuite),
      agencyManagement: text.includes(constants.agencyManagement),
      policyDocuments: text.includes(constants.policyDocumentsPortal),
    };
  
    const buttonContent = (
      <>
        <span className={'boxLink-text h6-font-style'}>{parse(box.text)}</span>
        <img className='forward-arrow' src={forwardArrow} alt='forward' />
      </>
    );
  
    if (actionTypes.policyManagement) {
      return createFormButton(index, box, handlePolicyManagementSubmit, buttonContent);
    }
    if (actionTypes.agencyManagement) {
      return createButton(index, box, navAgencyManagement, buttonContent);
    }
    if (!actionTypes.policyDocuments) {
      return createAnchorButton(index, box, buttonContent);
    }
    return createFormButton(index, box, handleSubmit, buttonContent, true);
  }
  
  function createButton(index, box, onClick, content) {
    return (
      <Button key={index} ref={scrollRefs.current[index]} id={box.id} className={'boxLink-' + box.boxStyle} variant='contained' onClick={onClick}>
        {content}
      </Button>
    );
  }
  
  function createAnchorButton(index, box, content) {
    return (
      <Button key={index} ref={scrollRefs.current[index]} id={box.id} className={'boxLink-' + box.boxStyle} variant='contained' href={box.url} target='_blank'>
        {content}
      </Button>
    );
  }
  
  function createFormButton(index, box, onSubmit, content, isPolicyDoc = false) {
    return (
      <form key={index} className='boxLink-form' name='input' action={isPolicyDoc ? appSettings.AGENT_REDIRECT_URL : box.url} method='post' target='_blank' onSubmit={onSubmit} ref={formRef}>
        <Button key={index} ref={scrollRefs.current[index]} id={box.id} className={'boxLink-' + box.boxStyle} variant='contained' type='submit' value='Submit'>
          {isPolicyDoc && <input type='hidden' name='login' ref={inputRef} />}
          {content}
        </Button>
      </form>
    );
  }
  
  async function handlePolicyManagementSubmit(e) {
    e.preventDefault();
    const newURL = await handleNavigate(selectedUser.new);
    if (newURL) {
     window.open(newURL, '_self');
    }
  }
}

export default AgentShopfloorHome;